import { render, staticRenderFns } from "./NumberMatcher.vue?vue&type=template&id=ee4994c6&scoped=true&"
import script from "./NumberMatcher.vue?vue&type=script&lang=js&"
export * from "./NumberMatcher.vue?vue&type=script&lang=js&"
import style0 from "./NumberMatcher.vue?vue&type=style&index=0&id=ee4994c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4994c6",
  null
  
)

export default component.exports